// extracted by mini-css-extract-plugin
module.exports = {"block":"index_block_3jTqM","label":"index_label_2Uk9t","item":"index_item_14Aso","itemTitle":"index_itemTitle_3vXF0"};